import React from "react";
import styled from "styled-components";

import { IUser } from "../../interfaces";
import List from "../molecules/List";
import User from "../molecules/User";

interface IProps {
  users: IUser[];
  selectUser: (user: IUser) => void;
}
const UserList: React.FC<IProps> = ({ users, selectUser, ...props }) => {
  return (
    <CustomList
      {...props}
      items={users.map<React.ReactElement<HTMLLIElement>>(user => (
        <User user={user} onClickUser={selectUser} />
      ))}
      inOrder={false}
      style={{ listStyle: "none" }}
    />
  );
};

export default UserList;

const CustomList = styled(List)``;
